const translations = {
  "en": {
    "Accounts Payable": "Accounts Payable",
    "Accounts Receivable": "Accounts Receivable",
    "As of today:": "As of today:",
    "At close: %{var0}": "At close: %{var0}",
    "Book Value Per Share": "Book Value Per Share",
    "Capital Expenditures": "Capital Expenditures",
    "Cash & Equivalents": "Cash & Equivalents",
    "Cash & Short-Term Investments": "Cash & Short-Term Investments",
    "Cash Growth": "Cash Growth",
    "Cash Income Tax Paid": "Cash Income Tax Paid",
    "CLOSED_MARKET: %{var0}": "CLOSED_MARKET: %{var0}",
    "Common Dividends Paid": "Common Dividends Paid",
    "Common Stock": "Common Stock",
    "Comprehensive Income & Other": "Comprehensive Income & Other",
    "Cost of Revenue": "Cost of Revenue",
    "Current Portion of Long-Term Debt": "Current Portion of Long-Term Debt",
    "D&A For EBITDA": "D&A For EBITDA",
    "Depreciation & Amortization": "Depreciation & Amortization",
    "Dividends": "Dividends",
    "Earning": "Earnings",
    "EBIT": "EBIT",
    "EBIT Margin": "EBIT Margin",
    "EBITDA": "EBITDA",
    "EBITDA Margin": "EBITDA Margin",
    "Edgen AI": "Ed AI",
    "Effective Tax Rate": "Effective Tax Rate",
    "EPS (Diluted)": "EPS (Diluted)",
    "EPS Growth": "EPS Growth",
    "Filing Date Shares Outstanding": "Filing Date Shares Outstanding",
    "Financial": "Financial",
    "Financing Cash Flow": "Financing Cash Flow",
    "Free Cash Flow": "Free Cash Flow",
    "Free Cash Flow Growth": "Free Cash Flow Growth",
    "Free Cash Flow Margin": "Free Cash Flow Margin",
    "Free Cash Flow Per Share": "Free Cash Flow Per Share",
    "Gross Margin": "Gross Margin",
    "Gross Profit": "Gross Profit",
    "Income Tax Expense": "Income Tax Expense",
    "Inventory": "Inventory",
    "Investing Cash Flow": "Investing Cash Flow",
    "Long-Term Debt": "Long-Term Debt",
    "Long-Term Investments": "Long-Term Investments",
    "LUNCH: %{var0}": "Noon Break: %{var0}",
    "Net Cash (Debt)": "Net Cash (Debt)",
    "Net Cash Flow": "Net Cash Flow",
    "Net Cash Per Share": "Net Cash Per Share",
    "Net Debt Issued (Repaid)": "Net Debt Issued (Repaid)",
    "Net Income": "Net Income",
    "Net Income Growth": "Net Income Growth",
    "Operating Cash Flow": "Operating Cash Flow",
    "Operating Cash Flow Growth": "Operating Cash Flow Growth",
    "Operating Expenses": "Operating Expenses",
    "Operating Margin": "Operating Margin",
    "Other Current Assets": "Other Current Assets",
    "Other Current Liabilities": "Other Current Liabilities",
    "Other Financing Activities": "Other Financing Activities",
    "Other Investing Activities": "Other Investing Activities",
    "Other Long-Term Assets": "Other Long-Term Assets",
    "Other Long-Term Liabilities": "Other Long-Term Liabilities",
    "Other Non Operating Income (Expenses)": "Other Non Operating Income (Expenses)",
    "Other Operating Activities": "Other Operating Activities",
    "Other Receivables": "Other Receivables",
    "Post-market: %{var0}": "Post-market: %{var0}",
    "Pre-market: %{var0}": "Pre-market: %{var0}",
    "Pretax Income": "Pretax Income",
    "Price": "Price",
    "Profit Margin": "Profit Margin",
    "Property, Plant & Equipment": "Property, Plant & Equipment",
    "Receivables": "Receivables",
    "REGULAR_MARKET:": "REGULAR_MARKET:",
    "Repurchase of Common Stock": "Repurchase of Common Stock",
    "Research & Development": "Research & Development",
    "Retained Earnings": "Retained Earnings",
    "Revenue": "Revenue",
    "Revenue Growth (YoY)": "Revenue Growth (YoY)",
    "Selling, General & Admin": "Selling, General & Admin",
    "Shareholders' Equity": "Shareholders' Equity",
    "Shares Change (YoY)": "Shares Change (YoY)",
    "Shares Outstanding (Diluted)": "Shares Outstanding (Diluted)",
    "Short-Term Debt": "Short-Term Debt",
    "Short-Term Investments": "Short-Term Investments",
    "Stock Price Prediction": "Stock Price Prediction",
    "Stock-Based Compensation": "Stock-Based Compensation",
    "Tangible Book Value Per Share": "Tangible Book Value Per Share",
    "Total Assets": "Total Assets",
    "Total Common Shares Outstanding": "Total Common Shares Outstanding",
    "Total Current Assets": "Total Current Assets",
    "Total Current Liabilities": "Total Current Liabilities",
    "Total Debt": "Total Debt",
    "Total Liabilities": "Total Liabilities",
    "Total Liabilities & Equity": "Total Liabilities & Equity",
    "Unlevered Free Cash Flow": "Unlevered Free Cash Flow",
    "Working Capital": "Working Capital"
  },
  "zh-tw": {
    "Accounts Payable": "應付帳款",
    "Accounts Receivable": "應收帳款",
    "As of today:": "截至今日：",
    "At close: %{var0}": "收盤價：%{var0}",
    "Book Value Per Share": "每股帳面價值",
    "Capital Expenditures": "資本支出",
    "Cash & Equivalents": "現金及等價物",
    "Cash & Short-Term Investments": "現金和短期投資",
    "Cash Growth": "現金成長",
    "Cash Income Tax Paid": "已付所得稅現金",
    "CLOSED_MARKET: %{var0}": "休市：%{var0}",
    "Common Dividends Paid": "已付普通股股利",
    "Common Stock": "普通股",
    "Comprehensive Income & Other": "綜合收益及其他",
    "Cost of Revenue": "營收成本",
    "Current Portion of Long-Term Debt": "長期債務的當期部分",
    "D&A For EBITDA": "EBITDA 中的折舊與攤銷",
    "Depreciation & Amortization": "折舊與攤銷",
    "Dividends": "股利",
    "Earning": "財報",
    "EBIT": "EBIT",
    "EBIT Margin": "EBIT 利潤率",
    "EBITDA": "EBITDA",
    "EBITDA Margin": "EBITDA 利潤率",
    "Edgen AI": "Ed AI",
    "Effective Tax Rate": "有效稅率",
    "EPS (Diluted)": "每股盈餘 (稀釋)",
    "EPS Growth": "每股盈餘成長率",
    "Filing Date Shares Outstanding": "財報揭露日流通股數",
    "Financial": "財務",
    "Financing Cash Flow": "融資現金流",
    "Free Cash Flow": "自由現金流",
    "Free Cash Flow Growth": "自由現金流成長",
    "Free Cash Flow Margin": "自由現金流利潤率",
    "Free Cash Flow Per Share": "每股自由現金流",
    "Gross Margin": "毛利率",
    "Gross Profit": "毛利",
    "Income Tax Expense": "所得稅費用",
    "Inventory": "存貨",
    "Investing Cash Flow": "投資現金流",
    "Long-Term Debt": "長期負債",
    "Long-Term Investments": "長期投資",
    "LUNCH: %{var0}": "午盤休市：%{var0}",
    "Net Cash (Debt)": "淨現金 (負債)",
    "Net Cash Flow": "淨現金流",
    "Net Cash Per Share": "每股淨現金",
    "Net Debt Issued (Repaid)": "淨發行 (償還) 負債",
    "Net Income": "淨利",
    "Net Income Growth": "淨利成長",
    "Operating Cash Flow": "營運現金流",
    "Operating Cash Flow Growth": "營運現金流成長",
    "Operating Expenses": "營業費用",
    "Operating Margin": "營業利益率",
    "Other Current Assets": "其他流動資產",
    "Other Current Liabilities": "其他流動負債",
    "Other Financing Activities": "其他籌資活動",
    "Other Investing Activities": "其他投資活動",
    "Other Long-Term Assets": "其他長期資產",
    "Other Long-Term Liabilities": "其他長期負債",
    "Other Non Operating Income (Expenses)": "其他非營業收入 (費用)",
    "Other Operating Activities": "其他營運活動",
    "Other Receivables": "其他應收款項",
    "Post-market: %{var0}": "盤後：%{var0}",
    "Pre-market: %{var0}": "盤前：%{var0}",
    "Pretax Income": "稅前淨利",
    "Price": "價格",
    "Profit Margin": "淨利率",
    "Property, Plant & Equipment": "不動產、廠房及設備",
    "Receivables": "應收款項",
    "REGULAR_MARKET:": "盤中：",
    "Repurchase of Common Stock": "普通股買回",
    "Research & Development": "研發",
    "Retained Earnings": "保留盈餘",
    "Revenue": "營收",
    "Revenue Growth (YoY)": "營收年增率 (YoY)",
    "Selling, General & Admin": "銷售、一般及管理費用",
    "Shareholders' Equity": "股東權益",
    "Shares Change (YoY)": "股數年變動 (YoY)",
    "Shares Outstanding (Diluted)": "稀釋後流通股數",
    "Short-Term Debt": "短期負債",
    "Short-Term Investments": "短期投資",
    "Stock Price Prediction": "股票價格預測",
    "Stock-Based Compensation": "股票薪酬",
    "Tangible Book Value Per Share": "每股有形帳面價值",
    "Total Assets": "總資產",
    "Total Common Shares Outstanding": "流通在外普通股總數",
    "Total Current Assets": "流動資產總額",
    "Total Current Liabilities": "流動負債總額",
    "Total Debt": "總債務",
    "Total Liabilities": "總負債",
    "Total Liabilities & Equity": "負債和權益總計",
    "Unlevered Free Cash Flow": "非槓桿自由現金流",
    "Working Capital": "營運資金"
  }
};

export default translations;
